import SnapPay from './SnapPay';

export default SnapPay;
